import React, { forwardRef } from 'react';

const VARIANT_CLASS = {
  default: 'card',
  glass: 'card-glass',
  inset:
    'rounded-2xl border border-white/[0.08] bg-black/20 backdrop-blur-xl p-6',
};

/**
 * @param {object} props
 * @param {'default'|'glass'|'inset'} [props.variant='default']
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
const Card = forwardRef(function Card(
  { variant = 'default', className = '', children, as: Comp = 'div', ...rest },
  ref
) {
  const base = VARIANT_CLASS[variant] || VARIANT_CLASS.default;
  return (
    <Comp ref={ref} className={`${base} ${className}`.trim()} {...rest}>
      {children}
    </Comp>
  );
});

export default Card;
